/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Areyousureyouwanttodeletethisimage8Inputs */

const en_areyousureyouwanttodeletethisimage8 = /** @type {(inputs: Areyousureyouwanttodeletethisimage8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this image?`)
};

const de_areyousureyouwanttodeletethisimage8 = /** @type {(inputs: Areyousureyouwanttodeletethisimage8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willst du dieses Bild wirklich löschen?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this image?" |
*
* @param {Areyousureyouwanttodeletethisimage8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const areyousureyouwanttodeletethisimage8 = /** @type {((inputs?: Areyousureyouwanttodeletethisimage8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Areyousureyouwanttodeletethisimage8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_areyousureyouwanttodeletethisimage8(inputs)
	return de_areyousureyouwanttodeletethisimage8(inputs)
});
export { areyousureyouwanttodeletethisimage8 as "areYouSureYouWantToDeleteThisImage" }